import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import packageJson from "../../../package.json";

const LoginFooter = (props) => {
  const navigation = useNavigate();
  let d = new Date();

  return (
    <>
      <Box sx={{ pt: 3, px: 10 }}>
        <Grid container spacing={1}>
          <Grid item sm={6} md={6} sx={{ textAlign: "left" }}>
            <Link
              underline="none"
              sx={{
                cursor: "pointer",
                fontSize: "0.9em",
                fontWeight: "500",
                "@media (min-width: 1636px)": {
                  fontSize: "1.3rem",
                },
              }}
              href="https://www.wordsworthelt.com/"
              target="_blank"
            >
              {"wordsworthelt.com"}
            </Link>
          </Grid>
          <Grid item sm={6} md={6} sx={{ textAlign: "right" }}>
            <Link
              underline="none"
              sx={{
                cursor: "pointer",
                fontSize: "0.9em",
                fontWeight: "500",
                "@media (min-width: 1636px)": {
                  fontSize: "1.3rem",
                },
              }}
            >
              {"+ 91-7948980451/52/53/54/55"}
            </Link>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ mt: 10 }}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid>
            <Link
              underline="none"
              sx={{
                cursor: "pointer",
                fontSize: "0.8em",
                fontWeight: "500",
                color: "#A9A9A9",
                "@media (min-width: 1636px)": {
                  fontSize: "1rem",
                },
              }}
              onClick={() => {
                navigation("/Disclaimer");
              }}
            >
              {"Disclaimer |"}
            </Link>
          </Grid>
          <Grid>
            <Link
              underline="none"
              sx={{
                cursor: "pointer",
                fontSize: "0.8em",
                fontWeight: "500",
                color: "#A9A9A9",
                "@media (min-width: 1636px)": {
                  fontSize: "1rem",
                },
              }}
              onClick={() => {
                navigation("/Terms");
              }}
            >
              {"Terms |"}
            </Link>
          </Grid>
          <Grid>
            <Link
              underline="none"
              sx={{
                cursor: "pointer",
                fontSize: "0.8em",
                fontWeight: "500",
                color: "#A9A9A9",
                "@media (min-width: 1636px)": {
                  fontSize: "1rem",
                },
              }}
              onClick={() => {
                navigation("/PrivacyPolicy");
              }}
            >
              {"Privacy policy"}
            </Link>
          </Grid>
        </Grid>
        <Grid>
          <Typography
            sx={{
              cursor: "pointer",
              fontSize: "0.8em",
              fontWeight: "500",
              color: "#A9A9A9",
              "@media (min-width: 1636px)": {
                fontSize: "1rem",
              },
            }}
          >
            Copyright ©2008-{d.getFullYear()}. ACTUniv™ or its affiliates, All
            rights reserved. v
            {process.env.REACT_APP_FOR_IPAD == 'true'
              ? packageJson.ipadVersion
              : packageJson.version}
          </Typography>
        </Grid>
      </Box>
    </>
  );
};

export default LoginFooter;
